import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ObserverContexts from "./components/Observer";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ObserverContexts>
      <App />
    </ObserverContexts>
  </React.StrictMode>
);
